import React from 'react';
import { Layout } from 'antd';
import './AppFooter.css';

const { Footer } = Layout;

const AppFooter = () => {
  return (
    <Footer className="app-footer">
      <div className="footer-content">
        <div className="footer-logo">
          <img src="/logo.png" alt="拔俗网络" className="footer-logo-img" />
          <div className="footer-company">
            <div className="footer-company-name">拔俗网络</div>
            <div className="footer-company-slogan">提供专业的营商环境解决方案</div>
          </div>
        </div>
        <div className="footer-links">
          <div className="footer-link-group">
            <h4>关于我们</h4>
            <a href="#">公司介绍</a>
            <a href="#">服务条款</a>
            <a href="#">隐私政策</a>
          </div>
          <div className="footer-link-group">
            <h4>帮助中心</h4>
            <a href="#">常见问题</a>
            <a href="#">操作指南</a>
            <a href="#">联系客服</a>
          </div>
          <div className="footer-link-group">
            <h4>联系方式</h4>
            <p>电话：400-123-4567</p>
            <p>邮箱：contact@ybbe.com</p>
            <p>地址：中国北京市朝阳区xx大厦</p>
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        © {new Date().getFullYear()} 拔俗网络科技有限公司 版权所有 | ICP备XXXXXXXX号
      </div>
    </Footer>
  );
};

export default AppFooter; 